







import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
@Component
export default class IntroduceList extends Vue {
  @Prop() introducePic: any
}
